import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=8ca89c9c"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports